"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** Platform UI Components */
var Label_1 = require("@idp/ui-components/components/atoms/Label");
/** Stylesheets */
var icons = require("../../../styles/att-icon-login.scss");
var styles = require("./InlineError.scss");
var InlineError = /** @class */ (function (_super) {
    __extends(InlineError, _super);
    function InlineError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineError.prototype.render = function () {
        return (React.createElement("div", { className: styles.errorMsg, "data-test-id": this.props.testId },
            React.createElement("i", { className: [icons.attIconLogin, icons.attIconLoginBadgealert].join(' '), role: "img", "aria-label": this.props.options.accessibilityText }),
            React.createElement("div", { "aria-live": "assertive", role: "alert" },
                React.createElement(Label_1.default, { data: {
                        text: this.props.data.inlineErrorText,
                    } }))));
    };
    return InlineError;
}(React.Component));
exports.default = InlineError;
//# sourceMappingURL=InlineError.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InlineError/InlineError.js
// module id = 354
// module chunks = 8